/* =======================================================================
   Poem — Poesia "Viva la Pizza!!!" su sfondo terracotta
   =======================================================================
   Il testo della poesia (e firma) è in src/data/copy.js → sezione "poem".
   ======================================================================= */
import { useLang } from "@/context/LanguageContext";

export default function Poem({ copy }) {
  const { lang, tr } = useLang();
  const lines = copy.poem.lines[lang];
  return (
    <section
      data-testid="poem"
      className="relative bg-[#BC472A] text-[#F7F4EB] py-28 lg:py-44 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.12] mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/></filter><rect width='200' height='200' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="relative mx-auto max-w-[1100px] px-6 lg:px-10">
        <p className="text-[0.72rem] tracking-[0.4em] uppercase text-[#F7F4EB]/80 mb-10">
          — Massimiliano Ciaffone
        </p>
        <h2 className="font-serif italic font-light text-[clamp(3.5rem,11vw,9rem)] leading-[0.9] tracking-tight mb-12">
          {tr(copy.poem.title)}
        </h2>
        <div className="max-w-2xl">
          {lines.map((line, i) =>
            line === "" ? (
              <div key={i} className="h-4" />
            ) : (
              <p
                key={i}
                className="font-serif text-xl lg:text-2xl leading-[1.5] text-[#F7F4EB]/95"
              >
                {line}
              </p>
            )
          )}
        </div>
        <p className="font-handwriting text-5xl mt-12 text-[#E6C9A8]">Le Simpatiche Canaglie</p>
      </div>
    </section>
  );
}
